import { Grid, IconButton } from "@mui/material";
import React from "react";
import CrossIcon from "src/icons/CrossIcon";
import { useDepositStyles } from "./deposit.styles";

interface DepositErrorProps {
  message: any;
  onClose: () => void;
}

const DepositMessage = (props: DepositErrorProps): JSX.Element => {
  const { message, onClose } = props;
  const classes = useDepositStyles();

  const eachRecursive = (obj: Record<string, any>): string => {
    for (const key in obj) {
      if (typeof obj[key] == "object" && obj[key] !== null) {
        eachRecursive(obj[key]);
      }

      if (key === "message" || key === "response") {
        return obj[key];
      } else {
        return "Error orccured";
      }
    }
    return "Error orccured";
  };

  const errorMsg = React.useMemo((): string => {
    if (!message) return "";

    if (typeof message === "string") return message as string;

    if (typeof message === "object") eachRecursive(message);

    if (message.includes("Thanks for submitting")) return message;

    return "Error occured";
  }, [message]);

  return (
    <Grid
      container
      sx={{ padding: "16px" }}
      className={classes.errorContainer}
      data-testid="deposit-modal-message">
      <Grid item container justifyContent="flex-end" sx={{ height: "fit-content" }}>
        <IconButton onClick={onClose}>
          <CrossIcon color="#000" width="16px" height="16px" />
        </IconButton>
      </Grid>

      <Grid item container justifyContent="center">
        <h3>{errorMsg}</h3>
      </Grid>
    </Grid>
  );
};

export default DepositMessage;
